export default __webpack_public_path__ + "static/media/property_126.d7133cbc.png";